
import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';
import { defaultFilters, Filters } from '@/store/modules/defaultStates/filters';
import { AnthropometryResults } from '@smartplus/components';

export default defineComponent({
  name: 'AnthroAnalysis',
  components: {
    AnthropometryResults,
  },
  data() {
    return {
      onMount: false,
      filters: defaultFilters,
    };
  },
  computed: {
    ...mapGetters('anthroAnalysis', {
      getAnthroAnalysis: 'getAnalysis',
      getAnalysisLoading: 'getAnalysisLoading',
    }),
  },
  methods: {
    async onFilterChange(filter: Filters) {
      await this.$store.dispatch('anthroAnalysis/updateAnalysis', filter);
      this.filters = filter;
    },
  },
});
